angular.module 'zc.projects'

.factory 'SettingStatus', ->
  service =
    statuses:
      installationCompleted: false
      installationReady: false
      trackingTag: false
      conversionTag: false
      conversionUrl: false
      testConversion: false
      excludeIp: false
      domain: false
      loginEvaluator: false
      newsletterParameter: false
      billingContractInformation: false
      billingInformation: false
      billingRepresentativeInformation: false
      billingSettingsCompleted: false

    updateProjectStatus: (project) ->
      @statuses.installationCompleted = project.campaign_status is 'completed'
      @statuses.conversionUrl = !!project.conversion_urls_memo
      @statuses.testConversion =  !!(!project.has_test_conversion or project.test_conversion_memo)
      @statuses.domain = !!(!project.has_multiple_domains or project.multiple_domains_memo)
      @statuses.loginEvaluator = !!(!project.has_login_evaluator or project.login_evaluator_memo)
      @statuses.newsletterParameter = !!(!project.has_newsletter_parameter or project.newsletter_parameter_memo)
      @statuses.billingContractInformation = @isBillingContractInformationComplete(project)
      @statuses.billingInformation = @isBillingInformationComplete(project)
      @statuses.billingRepresentativeInformation = @isBillingRepresentativeInformationComplete(project)
      @statuses.billingSettingsCompleted = @isBillingSettingsCompleted(project)
      @statuses.trackingTag = !!(project.tracking_tag_confirmed_at or project.tracking_tag_confirmed_by)
      @statuses.conversionTag = !!(project.conversion_tag_confirmed_at or project.conversion_tag_confirmed_by) or project.is_wevnal

      @updateInstallationReady()

    updateInstallationReady: ->
      @statuses.installationReady = @statuses.trackingTag &&
                                    @statuses.conversionTag &&
                                    @statuses.conversionUrl &&
                                    @statuses.testConversion &&
                                    @statuses.excludeIp &&
                                    @statuses.domain

    isBillingContractInformationComplete: (project) ->
      (
        project.sales_entity_fullname is 'Appier Japan (JP)' &&
        project.company_name &&
        project.representative &&
        project.postal_code &&
        project.address &&
        project.phone_number
      ) || (
        project.sales_entity_fullname isnt 'Appier Japan (JP)' &&
        project.company_name
      )

    isBillingInformationComplete: (project) ->
      project.billing_company_name &&
      project.billing_postal_code &&
      project.billing_address &&
      project.billing_phone_number

    isBillingRepresentativeInformationComplete: (project) ->
      project.billing_representatives &&
      project.billing_representatives[0] &&
      project.billing_representatives[0].email &&
      project.billing_representatives[0].full_name

    isBillingSettingsCompleted: (project) ->
      return @statuses.billingContractInformation unless project.is_direct_selling

      @statuses.billingContractInformation &&
      @statuses.billingInformation &&
      @statuses.billingRepresentativeInformation


    updateExcludeIpStatus: (excludeIps) ->
      @statuses.excludeIp = !!excludeIps.length
      @updateInstallationReady()

  service



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/setting_status.service.coffee